<template>
    <footer class="menu-footer">
        <section class="logo">

            <router-link to="/fr" v-if="lang == 'fr'">
                <img src="../assets/logo_adc.png" alt="" />
            </router-link>

            <router-link to="/en" v-if="lang == 'en'">
                <img src="../assets/logo_adc.png" alt="" />
            </router-link>
        </section>

        <section class="links">
            <template v-if="lang == 'fr'">
                <a href="../../static/pdf/web/lesgantsdamelie_cgv.pdf" target="_blank">conditions générales de vente</a>

                <router-link to="/mentions-legales">mentions légales</router-link>
                <router-link to="/contact">contact</router-link>
            </template>
            <template v-if="lang == 'en'">
                <a href="../../static/pdf/web/lesgantsdamelie_cgv.pdf" target="_blank">terms & conditions</a>
                <router-link to="/legal-terms">legal terms</router-link>
                <router-link to="/contact-us">contact</router-link>
            </template>
        </section>
    </footer>
</template>

<script>
  export default {
    name: 'MenuFooter',
    props: ['lang'],
  };
</script>
<style lang="scss">
    .menu-footer{
        text-align: center;
        font-size:0.8rem;
    }

    .menu-footer .links a {
        display: inline-block;
        padding: 0 0.2rem;
        margin-bottom: 0.5rem;

        &.active {
            background-color: #ebe9e8;
            &:hover {
                color: #9c554b;
                cursor: default;
            }

        }

    }
    .menu-footer .logo {
        display: block;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/MenuFooter.vue